<div class="xr-auth" [dir]="options.dir!">
  <main class="xr-auth-main">
    <div class="xr-auth-column">
      <a [routerLink]="['/dashboard']" class="xr-auth-logo">
        <img src="/assets/images/logos/logo_green.png" alt="XR Support"/>
      </a>
      <app-messages></app-messages>
      <router-outlet></router-outlet>
    </div>
  </main>

  <aside class="xr-auth-side">
    <img src="/assets/images/logos/logo_square.svg" alt="" class="xr-auth-side-mark"/>
    <h2 class="xr-auth-side-title">{{ "login.side_title" | translate }}</h2>
    <p class="xr-auth-side-text">{{ "login.side_text" | translate }}</p>
  </aside>
</div>
